import $ from "jquery";
import Sharer from "sharer.npm.js";

const share = () => {
  if (document.querySelector("[data-sharer]")) {
    $("[data-sharer]").on("click", (e) => {
      e.preventDefault();
      const sharer = new Sharer(e.currentTarget);
      sharer.share();
    });
  }
};

export default share;
